/* eslint-disable no-use-before-define */
/**
 * Static class of utility functions, and the like.
 *
 * @namespace Util
 */
class Util {
  /**
   * Throws an error if `window.$` or `window.jQuery` is undefined
   *
   * @static
   * @memberof Util
   * @throws {ReferenceError}
   */
  static ensureJQuery() {
    if (typeof window.$ === 'undefined' || typeof window.jQuery === 'undefined')
      throw new ReferenceError('jQuery ($) is undefined. Please load jQuery before your bundle.');
  }

  /**
   * Get the viewport type, based on the specified breakpoints
   *
   * @static
   * @param {number} [desktopBreakpoint=970]
   * @param {number} [tabletBreakpoint=750]
   * @returns {ViewPort} The viewport (desktop|mobile|tablet)
   * @memberof Util
   */
  static getViewPort(desktopBreakpoint, tabletBreakpoint) {
    desktopBreakpoint = desktopBreakpoint || 970;
    tabletBreakpoint = tabletBreakpoint || 750;

    const width = window.innerWidth;

    if (width >= desktopBreakpoint) {
      return ViewPort.Desktop;
    }
    if (width >= tabletBreakpoint) {
      return ViewPort.Tablet;
    }
    return ViewPort.Mobile;
  }

  /**
   * Determine if `value` is NOT null, or undefined, or if `value` is a string, is NOT empty
   *
   * @static
   * @param {any} value
   * @returns {boolean} A boolean indication if `value` is not undefined, null, or an empty string
   * @memberof Util
   */
  static hasValue(value) {
    let hasValue = value !== undefined && value != null;
    if (hasValue && typeof value === 'string') hasValue = hasValue && value !== '';

    return hasValue;
  }

  /**
   * Check to see if site is running in Internet Explorer
   *
   * @static
   * @returns {boolean} True or false
   * @memberof Util
   */
  static isInternetExplorer() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    // eslint-disable-next-line no-useless-escape
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
  }

  /**
   * Trim whitespace from both sides of a string, as well as occurences of the specified character
   *
   * @static
   * @param {string} str
   * @param {string} char
   * @returns {string} The trimmed string
   * @memberof Util
   */
  static trim(str, char) {
    if (str == null || str === undefined) return '';

    let value = str.trim();
    if (Util.hasValue(char)) value = value.replace(new RegExp(`(^${char}|${char}$)`, 'g'), '');

    return value;
  }
}

export default Util;

/**
 * @enum {string} ViewPort
 * @memberof Util
 * @example
 * import Util, { ViewPort } from './util';
 * console.log(Util.getViewPort() === ViewPort.Desktop)  // -> true
 */
const ViewPort = {
  Desktop: 'desktop',
  Mobile: 'mobile',
  Tablet: 'tablet'
};
export { ViewPort };